module.exports = "<ng-transclude></ng-transclude>";